<template lang="pug">
  div
    .heading Reverse DNS Lookup
    .subtitle This page allows you to query for DNS records for a specific IP address.
    ReverseDNSLookup
</template>
<script>
import ReverseDNSLookup from "@/components/ReverseDNSLookup";

export default {
  components: {
    ReverseDNSLookup: ReverseDNSLookup,
  },
};
</script>
